import styled from "styled-components";

import { easingSeconds } from "../shared";
import { colors } from "../shared/colors"; // importing from shared caused crash
import { Flexbox } from "../shared/flexbox"; // importing from shared caused an error: Uncaught Error: Cannot create styled-component for component: undefined.
import Twitter from "../icons/Twitter";

export const SocialsWrapper = styled(Flexbox)`
    ${Twitter} {
        margin-left: 13px;
    }

    svg {
        transition: opacity ${easingSeconds};

        &:hover {
            opacity: 0.6;
        }
    }
`;

export const TextWrapper = styled.div`
    color: ${colors.emptySearchBG};
`;

export const Wrapper = styled.div`
    width: 100%;
    padding: 1rem;

    ${TextWrapper} {
        margin-left: 1rem;
    }

    ${SocialsWrapper} {
        margin-left: 10px;
    }
`;
